import React from "react";
import { sendFirebaseEvent, onFinishedWebView } from "../../../helper/mobile";
import leftArrowImg from "./arrow-left.svg";
import AppIcon from "../../../assets/images/AppIcon.png";
import { useNavigate } from "react-router-dom";

const CodeActivationHeader = () => {
  const navigate = useNavigate();

  const onClickHandler = () => {
    navigate(-1);
    sendFirebaseEvent("dp_activate_plan_close", "click_event");
    onFinishedWebView();
  };

  return (
    <div className="code-activation-header">
      <img
        onClick={onClickHandler}
        src={leftArrowImg}
        alt=""
        className="left-arrow-img"
      />
      <div className="text-center mt-4">
        <img className="mb-3" src={AppIcon} alt="" width="72px" height='72px'/>
        <h2 className="mb-1">Activate your health plan</h2>
        <p className="mb-0">
          Our health plans combine behavioural psychology, technology, and
          expert nutritionist coaching
        </p>
      </div>
    </div>
  );
};

export default CodeActivationHeader;
